import { Image } from 'shared/components';
import defaultImage from 'assets/images/default.jpg';

const ReviewProductItem = ({ productData, date, price }) => {
  const { images, name, description } = productData;

  return (
    <div className="ordereditem_block rvw_productstrip">
      <div className="checkout_item_area d-flex">
        <div className="cart_item_detl width_inherit d-flex">
          <a
            href="/"
            onClick={(e) => e.preventDefault()}
            className="item_display"
          >
            <Image
              src={images && images.length ? images[0].path : defaultImage}
              className="img-responsive"
              alt="product"
              relativeSrc
            />
          </a>
          <div className="cart_item_desc">
            <h5>
              <a href="/" onClick={(e) => e.preventDefault()}>
                {name}
              </a>
            </h5>
            <p className="grey_text">{description}</p>
          </div>
        </div>
        <div className="cart_item_desc width_inherit pl-0 diff ml-0">
          <div className="size_n_quantity" />

          <div className="item_prc_block for_checkout">
            {price ? `₹${price}` : ''}
          </div>
        </div>
        <div className="estimated_delivery width_inherit pr-0">
          {date ? (
            <>
              <p>Delivered on {date}</p>
              <p className="dlvry_note">Your item has been delivered</p>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ReviewProductItem;
